module.exports = __webpack_public_path__ + "img/tv.be5030ca.webp";